/**
 * ATTEST_HISTORY_ENABLED — the letter/refusal history surface (brief screen 7).
 *
 * Default OFF, and it must stay off until persistence actually lands. Session 1
 * writes nothing: every attest POST is marked `# conformance: read-only` and
 * returns a computed artifact. A history screen fed by that API could only show
 * an empty list or an invented one, and the brief is explicit — "if persistence
 * isn't in yet, stub behind a feature flag; do not fake it."
 *
 * Baked at build time by Vite, so flipping it needs a rebuild:
 *   docker/ACR:  --build-arg "VITE_ATTEST_HISTORY_ENABLED=true"
 *   local dev:   VITE_ATTEST_HISTORY_ENABLED=true npm run dev
 */
export const ATTEST_HISTORY_ENABLED =
  String(import.meta.env.VITE_ATTEST_HISTORY_ENABLED ?? '').toLowerCase() === 'true'
